import { useState, useContext, useEffect, useRef, useCallback } from "react";
import TextArea from "../../Common/TextArea/TextArea";
import Button from "../../Common/Button/Button";
import "./AiDrivenScreening.css";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import SendIcon from "../../Assets/Images/send-icon.png";
import BotReplyIcon from "../../Assets/Images/VybogTAL GEN Icon White.svg";
import { DynamicContext } from "../../Context/DynamicContext";
import paperClip from "../../Assets/Images/paperClip.png";
import FileIcon from "../../Common/Common-Function/IconMapping";
import expandIcon from "../../Assets/Images/expandIcon.png";
import Badge from "@mui/material/Badge";
import {
  displayFileName,
  applyEllipsis,
  BotResponseStarIcon,
  parseMessageText,
} from "../../Common/Common-Function/CommonFunctions";
import DarkPaperClip from "../../Assets/Images/dark-paperclip.png";
import OpenChatTabIcon from "../../Assets/Images/channel-list-close-tab-icon.png";
import OpenChatTabDarkIcon from "../../Assets/Images/channel-list-close-tab-dark-icon.png";
import CloseChatTabIcon from "../../Assets/Images/chat-history-close-icon.png";
import CloseChatTabDarkIcon from "../../Assets/Images/chat-history-close-dark-icon.png";
import CustomTooltip from "../../Common/Tooltip/Tooltip";
import { post, get, put, deleteRequest } from "../../helper/Api_helper";
import { useNavigate, useParams } from "react-router";
import VybogTALLoaderAnimation from "../../Common/Dynamic-Animations/DynamicAnimations";
import {
  VYLABS_BASE_URL,
  CREATE_CHAT_CHANNEL_URL,
  GET_CHAT_CHANNEL_LIST_URL,
  GET_CHAT_MESSAGES_LIST_URL,
  DELETE_CHAT_CHANNEL_URL,
  WEB_SOCKET_URL,
  GET_CANDIDATE_BY_ID,
  PROCESS_CANDIDATE_CONVERSATION,
  PROCESS_JOB_CONVERSATION,
  GET_CURRENT_CONVERSATION_TITLE,
  GET_JOB_DETAILS_BY_ID,
  UPDATE_CANDIDATE_DETAILS,
  UPDATE_JOB,
  RECOMMEND_JOBS,
  CHATBOT_EXECUTE_SCHEDULE_INTERVIEW,
  GET_VENDOR_DETAILS_BY_ID,
} from "../../helper/url_helper";
import { debounce } from "lodash";
import {
  groupByDateCategory,
  renderInlineMarkdown,
  getBulletContent,
  renderBotContent,
} from "../../Common/Common-Function/CommonFunctions";
import { v4 as uuidv4 } from "uuid";
import CandidateConvoIcon from "../../Assets/Images/candidate-convo-icon.svg";
import JobConvoIcon from "../../Assets/Images/job-convo-icon.svg";
import CancelIcon from "@mui/icons-material/Cancel";
import AnimationPlayer from "../../Common/Animation-Player/AnimationPlayer";
import ThinkingBubble from "../../Common/ThinkingBubble/ThinkingBubble";
import { useThinkingFallback } from "../../helper/useThinkingFallback";
import { RECOVERY_FAILED_MESSAGE } from "../../helper/chatRecovery";
import sendIconAnimation from "../../Assets/Json/Vybogtal Up Down Animation.json";
import renameIcon from "../../Assets/Images/rename-icon.png";
import renameDarkIcon from "../../Assets/Images/rename-dark-icon.png";
import chatDeleteIcon from "../../Assets/Images/chat-delete-icon.png";
import Menuselector from "../../Common/Drop-Down-Menu/Menuselector";
import { useLocation } from "react-router-dom";
import Card from "../../Common/Card/Card";
import SidePopup from "../../Common/SidePopup/SidePopup";
import cepheaChatBannerIcon from "../../Assets/Images/Cephea Chat Banner AI Icon.svg";
import { ConfirmationPopup } from "../../Common/PopupStyles/PopupComponent";
import SparkleButton from "../../Common/SparkleButton/SparkleButton";
import CandidateDetailsContainer from "../../Common/Candidate-Details-Container/CandidateDetailsContainer";
import { useFormik } from "formik";
import backArrowIcon from "../../Assets/Images/arrow-back-icon.png";
import JobsCard, { JobStatusUpdatePopup } from "../../Common/Card/JobsCard";
import JobsDetailsContainer from "../../Common/Jobs-Details-Container/JobsDetailsContainer";
import calenderIcon from "../../Assets/Images/calender-active-icon.png";
import timerIcon from "../../Assets/Images/timer-active-icon.png";
import candidateNameIcon from "../../Assets/Images/candidate-name-active-icon.png";
import candidateEmailIcon from "../../Assets/Images/email-active-icon.png";
import interviewerIcon from "../../Assets/Images/interviewer-active-icon.png";

function AiDrivenScreening() {
  const navigate = useNavigate();
  const location = useLocation();
  const { searchData } = location.state || {};
  const hasTriggered = useRef(false);
  const observer = useRef();
  const {
    isDarkMode,
    userDetails,
    closeTab,
    setIsFromCandidateRecommendedJobs,
  } = useContext(DynamicContext);
  const { id } = useParams();
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [messageOffset, setmessageOffset] = useState(0);
  const [messageHasMore, setmessageHasMore] = useState(true);
  const [messageIsLoading, setmessageIsLoading] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [messages, setMessages] = useState([]);
  const [AiDrivenUploadedFiles, setAiDrivenUploadedFiles] = useState([]);
  const [isContainerExpanded, setIsContainerExpanded] = useState(true);
  const [chatChannelID, setChatChannelID] = useState(null);
  const [deleteChannelID, setDeleteChannelID] = useState(null);
  const [selectedChannelID, setSelectedChannelID] = useState(null);
  const [chatChannelsList, setChatChannelsList] = useState([]);
  const [isChatChannelOpen, setIsChatChannelOpen] = useState(true);
  const [getChatMessages, setChatMessages] = useState([]);
  const [openJobDescription, setOpenJobDescription] = useState(false);
  const [searchChannel, setSearchChannel] = useState("");
  const [isMessagesLoading, setIsMessagesLoading] = useState(false);
  const [socket, setSocket] = useState(null);
  const [hoveredChannel, setHoveredChannel] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedChannelInitialContent, setSelectedChannelInitialContent] =
    useState("");
  const [isBotProcessing, setIsBotProcessing] = useState(false);
  const [isCreatingChannel, setIsCreatingChannel] = useState(false);
  const [openDropDownMenu, setOpenDropDownMenu] = useState(false);
  const [isFromNavigation, setIsFromNavigation] = useState(false);
  const [isInitializing, setIsInitializing] = useState(true);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [jobActiveTab, setJobActiveTab] = useState("Job Details");
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const [chatType, setChatType] = useState(null);
  const [openConversationLimitPopup, setOpenConversationLimitPopup] =
    useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [jobsSideContainerOpen, setJobsSideContainerOpen] = useState(false);
  const [hasSearched, setHasSearched] = useState(true);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isEditingCandidate, setIsEditingCandidate] = useState(false);
  const [originalCandidateData, setOriginalCandidateData] = useState(null);
  const [editedCandidateData, setEditedCandidateData] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [isEditingJob, setIsEditingJob] = useState(false);
  const [originalJobData, setOriginalJobData] = useState(null);
  const [editedJobData, setEditedJobData] = useState(null);
  const [emailTouched, setEmailTouched] = useState(false);
  const [isAllCandidatesActive, setIsAllCandidatesActive] = useState(true);
  const [allCanList, setAllCanList] = useState([]);
  const [searchResultCandidateIds, setSearchResultCandidateIds] = useState([]);
  const sentContextChannelIds = useRef(new Set());
  const [myCanList, setMyCanList] = useState([]);
  const [assignedCount, setAssignedCount] = useState(0);
  const [assignedVendor, setAssignedVendor] = useState(null);
  const [topCandidates, setTopCandidates] = useState([]);
  const [topJobs, setTopJobs] = useState([]);
  const [interviewSchedulingStatus, setInterviewSchedulingStatus] = useState(
    new Map(),
  );
  const [conversationContext, setConversationContext] = useState({
    candidateIds: [],
    jobIds: [],
  });
  const reconnectTimeoutRef = useRef(null);
  const socketRef = useRef(null);
  const offsetRef = useRef(offset);
  const MAX_RECONNECT_ATTEMPTS = 5;
  const BASE_RECONNECT_DELAY = 1000;
  const PING_INTERVAL = 30000;
  const PING_TIMEOUT = 10000;
  const pingIntervalRef = useRef(null);
  const pingTimeoutRef = useRef(null);
  const responseReceivedRef = useRef(false);
  const isConnectingRef = useRef(false);
  const lastMessageRef = useRef(null);
  const messageQueueRef = useRef([]);
  const lastPingTimeRef = useRef(null);

  const isAwaitingReply = messages.some((m) => m.isLoading);
  const resolveLoadingMessages = (text) => {
    setMessages((prev) => {
      const idx = prev.findIndex((m) => m.isLoading || m.isStreaming);
      if (idx === -1) return prev;
      const updated = [...prev];
      updated[idx] = {
        ...updated[idx],
        text,
        isLoading: false,
        isStreaming: false,
      };
      return updated;
    });
    responseReceivedRef.current = true;
    setIsBotProcessing(false);
  };
  useThinkingFallback({
    active: isAwaitingReply,
    getChannelId: () => chatChannelID,
    responseReceivedRef,
    onRecovered: (answer) => resolveLoadingMessages(answer),
    onExhausted: () => resolveLoadingMessages(RECOVERY_FAILED_MESSAGE),
  });

  const messagesContainerRef = useRef(null);
  const chatListContainerRef = useRef(null);

  const setInterviewStatus = (messageId, status) => {
    setInterviewSchedulingStatus((prev) =>
      new Map(prev).set(messageId, status),
    );
  };

  const getInterviewStatus = (messageId) => {
    return (
      interviewSchedulingStatus.get(messageId) || {
        isScheduling: false,
        isScheduled: false,
      }
    );
  };

  const isInterviewScheduled = (messageId) => {
    return getInterviewStatus(messageId).isScheduled;
  };

  const isInterviewScheduling = (messageId) => {
    return getInterviewStatus(messageId).isScheduling;
  };

  const scheduleInterview = async (messageId, decoratorData) => {
    if (!decoratorData) {
      Toast("error", "No interview data available");
      return;
    }
    if (isInterviewScheduling(messageId) || isInterviewScheduled(messageId)) {
      return;
    }
    setInterviewStatus(messageId, { isScheduling: true, isScheduled: false });

    try {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const response = await post(
        VYLABS_BASE_URL,
        CHATBOT_EXECUTE_SCHEDULE_INTERVIEW,
        {
          event_args: JSON.stringify(decoratorData.parsedEventArgs),
          event_type: decoratorData.type,
          message_id: messageId,
          timezone: userTimezone,
        },
      );

      if (response === "executed") {
        setInterviewStatus(messageId, {
          isScheduling: false,
          isScheduled: true,
        });
        Toast("success", "Interview scheduled successfully!");
      } else {
        setInterviewStatus(messageId, {
          isScheduling: false,
          isScheduled: false,
        });
        Toast("error", "Failed to schedule interview");
      }
    } catch (error) {
      setInterviewStatus(messageId, {
        isScheduling: false,
        isScheduled: false,
      });
      Toast("error", "Error scheduling interview");
    }
  };

  const cancelInterview = (messageId) => {
    const confirmCancel = window.confirm(
      "Are you sure you want to cancel this interview scheduling?",
    );
    if (confirmCancel) {
      setInterviewStatus(messageId, {
        isScheduling: false,
        isScheduled: false,
      });
    }
  };

  const popupItems = [
    { name: "Rename", icon: isDarkMode ? renameDarkIcon : renameIcon },
    { name: "Delete", icon: chatDeleteIcon },
  ];

  const handleSelect = (item, rowIndex, chatChannelID) => {
    switch (item) {
      case "Rename":
        break;
      case "Delete":
        handleSelectDeleteChannel(chatChannelID);
        break;
      default:
        break;
    }
  };

  const fetchJobsList = useCallback(async (jobs = [], botMessageId) => {
    const detailedJobs = await Promise.all(
      jobs.map(async (job) => {
        try {
          const res = await get(
            VYLABS_BASE_URL,
            `${GET_JOB_DETAILS_BY_ID}?id=${job.job_id}`,
          );
          return {
            ...res.job,
            title: res.job.title,
            description: res.job.description,
            skills: res.job.skills
              ? Array.isArray(res.job.skills)
                ? res.job.skills
                : res.job.skills.split(",").map((skill) => skill.trim())
              : [],
            salary_min: res.job.salary_min,
            salary_max: res.job.salary_max,
            location: res.job.location,
            years_experience: res.job.years_experience,
            job_type: res.job.job_type,
            client: res.job.client,
          };
        } catch (err) {
          console.error(`Error fetching job by ID ${job.job_id}:`, err);
          return null;
        }
      }),
    );

    const filteredJobs = detailedJobs.filter(Boolean);

    setMessages((prev) => {
      const updated = [...prev];
      const botMessageIndex = updated.findIndex(
        (msg) => msg.id === botMessageId && msg.sender === "bot",
      );

      if (botMessageIndex !== -1) {
        updated[botMessageIndex] = {
          ...updated[botMessageIndex],
          isLoading: false,
          jobs: filteredJobs,
        };
      }

      return updated;
    });
    setIsBotProcessing(false);
  }, []);
  const initializeWebSocket = useCallback(() => {
    if (isConnectingRef.current) {
      console.log("Already attempting to connect, skipping...");
      return;
    }
    isConnectingRef.current = true;
    if (socketRef.current) {
      socketRef.current.close();
    }
    if (pingIntervalRef.current) {
      clearInterval(pingIntervalRef.current);
      pingIntervalRef.current = null;
    }
    if (pingTimeoutRef.current) {
      clearTimeout(pingTimeoutRef.current);
      pingTimeoutRef.current = null;
    }
    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current);
      reconnectTimeoutRef.current = null;
    }
    responseReceivedRef.current = false;
    const token = localStorage.getItem("token");
    const wsProtocol =
      window.location.protocol === "https:" ? "wss://" : "wss://";
    const wsUrl = `${wsProtocol}${WEB_SOCKET_URL}/ws?token=${encodeURIComponent(
      "Bearer " + token,
    )}`;
    try {
      console.log("Creating new WebSocket connection...");
      const ws = new WebSocket(wsUrl);
      socketRef.current = ws;
      setSocket(ws);
      ws.onopen = () => {
        console.log("WebSocket connection established");
        setReconnectAttempts(0);
        isConnectingRef.current = false;
        if (lastMessageRef.current) {
          console.log("Resending last message:", lastMessageRef.current);
          ws.send(lastMessageRef.current);
        }
        if (messageQueueRef.current.length > 0) {
          console.log(
            `Processing ${messageQueueRef.current.length} queued messages`,
          );
          messageQueueRef.current.forEach((msg) => {
            if (ws.readyState === WebSocket.OPEN) {
              ws.send(msg);
            }
          });
          messageQueueRef.current = [];
        }
        startPingInterval(ws);
      };
      ws.onmessage = (event) => {
        console.log("Raw WebSocket message:", event.data);
        if (event.data === "pong") {
          console.log("Pong received");
          if (pingTimeoutRef.current) {
            clearTimeout(pingTimeoutRef.current);
            pingTimeoutRef.current = null;
          }
          return;
        }

        try {
          console.log("WebSocket response received:", event.data);
          const separatorIndex = event.data.indexOf("|");
          if (separatorIndex === -1) {
            return;
          }
          const topic = event.data.substring(0, separatorIndex);
          const payload = event.data.substring(separatorIndex + 1);
          const trimmedTopic = topic.split(":")[0].trim();
          console.log("Parsed topic:", topic, "Trimmed topic:", trimmedTopic);

          const parseNestedJSON = (str) => {
            try {
              if (str === "reading message" || str === '"reading message"') {
                return null;
              }
              return JSON.parse(
                str
                  .replace(/^"+|"+$/g, "")
                  .replace(/\\"/g, '"')
                  .replace(/\\\\/g, "\\"),
              );
            } catch (error) {
              return {};
            }
          };
          const response = parseNestedJSON(payload);
          setMessages((prev) => {
            const updated = [...prev];
            const loadingIndex = updated.findIndex((msg) => msg.isLoading);

            let decoratorData = null;
            if (
              response &&
              (trimmedTopic === "screening-send-message-completed" ||
                trimmedTopic === "screening-message-update")
            ) {
              if (
                response.decorator &&
                response.decorator.type === "interview_schedule"
              ) {
                let eventArgs = response.decorator.event_args;
                if (typeof eventArgs === "string") {
                  try {
                    eventArgs = JSON.parse(eventArgs);
                  } catch (e) {
                    console.error(
                      "Failed to parse event_args in WS message",
                      e,
                    );
                  }
                }
                if (eventArgs && eventArgs.candidate_id) {
                  decoratorData = {
                    ...response.decorator,
                    parsedEventArgs: eventArgs,
                    message_id: response.message_id,
                  };
                }
              }
            }

            const findSimilarTopicWithID = `find-similar-resumes-completed:${userDetails?.id}`;

            if (topic === findSimilarTopicWithID) {
              console.log("Find similar resumes completed:", response);
              responseReceivedRef.current = true;

              try {
                const similarResumes = Array.isArray(response)
                  ? response
                  : JSON.parse(payload);
                if (
                  Array.isArray(similarResumes) &&
                  similarResumes.length > 0
                ) {
                  fetchResumesList(
                    similarResumes,
                    updated[loadingIndex]?.id || uuidv4(),
                  );
                } else {
                  if (loadingIndex !== -1) {
                    updated[loadingIndex] = {
                      ...updated[loadingIndex],
                      text: "No similar resumes found.",
                      isLoading: false,
                      resumes: [],
                    };
                  }
                  setTimeout(() => setIsBotProcessing(false), 0);
                }
              } catch (error) {
                console.error("Error parsing similar resumes payload:", error);
                if (loadingIndex !== -1) {
                  updated[loadingIndex] = {
                    ...updated[loadingIndex],
                    text: "Error processing resumes.",
                    isLoading: false,
                    resumes: [],
                  };
                }
                setTimeout(() => setIsBotProcessing(false), 0);
              }
            } else if (trimmedTopic === "screening-send-message-completed") {
              console.log("Screening message completed:", response);
              responseReceivedRef.current = true;
              let isFetchingDetails = false;

              if (response && response.answer) {
                const candidateIds = [];
                const lines = response.answer.split("\n");
                lines.forEach((line) => {
                  const match = line.match(/Candidate ID:\s*([a-f0-9]+)/);
                  if (match) {
                    candidateIds.push(match[1]);
                  }
                });

                if (loadingIndex !== -1) {
                  const filteredAnswer = lines
                    .filter((line) => !line.match(/Candidate ID:/))
                    .join("\n");
                  updated[loadingIndex] = {
                    ...updated[loadingIndex],
                    text: filteredAnswer,
                    isLoading: false,
                    resumes: candidateIds.map((id) => ({
                      decorator: decoratorData,
                      candidate_id: id,
                      name: "Loading...",
                    })),
                  };

                  if (candidateIds.length > 0) {
                    fetchResumesList(candidateIds, updated[loadingIndex]?.id);
                    isFetchingDetails = true;
                  } else {
                  }
                }
              } else {
                console.error("Invalid response format:", response);
                if (loadingIndex !== -1) {
                  updated[loadingIndex] = {
                    ...updated[loadingIndex],
                    isLoading: false,
                  };
                }
              }
              if (response && response.answer) {
                console.log("Raw bot response answer:", response.answer);
                const similarJobs = [];
                const lines = response.answer.split("\n");
                const similarJobsStart = lines.findIndex((line) =>
                  line.startsWith("Similar Jobs:"),
                );
                let similarJobsEnd = lines.length;

                if (similarJobsStart !== -1) {
                  for (let i = similarJobsStart + 1; i < lines.length; i++) {
                    if (
                      lines[i].startsWith("Currently, we have") ||
                      lines[i].startsWith("Similar Resumes:")
                    ) {
                      similarJobsEnd = i;
                      break;
                    }
                  }
                  for (let i = similarJobsStart + 1; i < similarJobsEnd; i++) {
                    const jobMatch = lines[i].match(
                      /-\s*(.*?)\s*\(ID:\s*([a-f0-9]+)\)/,
                    );
                    if (jobMatch) {
                      similarJobs.push({ job_id: jobMatch[2] });
                    }
                  }
                } else {
                  for (let i = 0; i < lines.length; i++) {
                    const jobMatch = lines[i].match(
                      /-\s*(.*?)\s*\(ID:\s*([a-f0-9]+)\)/,
                    );
                    if (jobMatch) {
                      similarJobs.push({ job_id: jobMatch[2] });
                    }
                  }
                }

                if (loadingIndex !== -1) {
                  const cleanedLines = lines.map((line) =>
                    line.replace(/\s*\(ID:\s*[a-f0-9-]+\)/i, ""),
                  );
                  const cleanedText = cleanedLines.join("\n");
                  updated[loadingIndex] = {
                    ...updated[loadingIndex],
                    text: cleanedText,
                    isLoading: false,
                    jobs: similarJobs.map((job) => ({
                      decorator: decoratorData,
                      job_id: job.job_id,
                      title: job.title || "Job Title",
                    })),
                  };

                  if (similarJobs.length > 0) {
                    console.log("All similar jobs to fetch:", similarJobs);
                    fetchJobsList(similarJobs, updated[loadingIndex]?.id);
                    isFetchingDetails = true;
                  } else {
                  }
                }
                if (decoratorData && loadingIndex !== -1) {
                  updated[loadingIndex] = {
                    ...updated[loadingIndex],
                    decorator: decoratorData,
                  };
                }
              } else {
                console.error("Invalid response format:", response);
                if (loadingIndex !== -1) {
                  updated[loadingIndex] = {
                    ...updated[loadingIndex],
                    isLoading: false,
                  };
                }
              }
              if (!isFetchingDetails) {
                setTimeout(() => setIsBotProcessing(false), 0);
              }
            } else if (trimmedTopic === "screening-total-tokens-err") {
              console.log("Token limit exceeded:", response);
              if (loadingIndex !== -1) {
                updated[loadingIndex] = {
                  ...updated[loadingIndex],
                  sender: "system",
                  text: "Token limit exceeded.",
                  isLoading: false,
                };
              }
              responseReceivedRef.current = true;
              setTimeout(() => setIsBotProcessing(false), 0);
            } else if (trimmedTopic === "screening-message-update") {
              console.log("Screening message update received:", response);
            } else {
              console.warn("Unhandled topic received:", topic);
            }

            return updated;
          });

          if (responseReceivedRef.current && ws.readyState === WebSocket.OPEN) {
            setTimeout(() => {
              ws.close(1000, "Response received, closing connection");
            }, 1000);
          }
        } catch (error) {
          console.error("Error processing WebSocket message:", error);
        }
      };
      ws.onclose = (event) => {
        console.log("WebSocket connection closed", event);
        isConnectingRef.current = false;
        if (pingIntervalRef.current) {
          clearInterval(pingIntervalRef.current);
          pingIntervalRef.current = null;
        }
        if (pingTimeoutRef.current) {
          clearTimeout(pingTimeoutRef.current);
          pingTimeoutRef.current = null;
        }
        if (
          event.code === 1006 ||
          (!responseReceivedRef.current && event.code !== 1000)
        ) {
          console.log(
            `Connection closed with code ${event.code}, attempting to reconnect...`,
          );
          handleReconnect();
        }
      };
      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
        isConnectingRef.current = false;
      };
    } catch (error) {
      console.error("Error creating WebSocket:", error);
      isConnectingRef.current = false;
      handleReconnect();
    }
  }, []);

  const startPingInterval = useCallback((ws) => {
    if (pingIntervalRef.current) {
      clearInterval(pingIntervalRef.current);
    }
    if (ws.readyState === WebSocket.OPEN) {
      console.warn("Sending initial ping");
      ws.send("ping");
      lastPingTimeRef.current = Date.now();
      pingTimeoutRef.current = setTimeout(() => {
        const timeSinceLastPing = Date.now() - lastPingTimeRef.current;
        if (timeSinceLastPing > PING_TIMEOUT) {
          console.log("No pong received within timeout, reconnecting...");
          ws.close(1000, "Ping timeout");
        }
      }, PING_TIMEOUT);
    }
    pingIntervalRef.current = setInterval(() => {
      if (ws.readyState === WebSocket.OPEN) {
        console.warn("Sending ping");
        ws.send("ping");
        lastPingTimeRef.current = Date.now();
        if (pingTimeoutRef.current) {
          clearTimeout(pingTimeoutRef.current);
        }
        pingTimeoutRef.current = setTimeout(() => {
          const timeSinceLastPing = Date.now() - lastPingTimeRef.current;
          if (timeSinceLastPing > PING_TIMEOUT) {
            console.log("No pong received within timeout, reconnecting...");
            ws.close(1000, "Ping timeout");
          }
        }, PING_TIMEOUT);
      }
    }, PING_INTERVAL);
  }, []);

  const handleReconnect = useCallback(() => {
    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      Toast("error", "Max reconnection attempts reached. Please refresh.");
      return;
    }
    const delay = Math.min(
      BASE_RECONNECT_DELAY * Math.pow(2, reconnectAttempts) +
        Math.random() * 1000,
      30000,
    );
    reconnectTimeoutRef.current = setTimeout(() => {
      setReconnectAttempts((prev) => prev + 1);
      initializeWebSocket();
    }, delay);
  }, [initializeWebSocket, reconnectAttempts]);

  useEffect(() => {
    offsetRef.current = offset;
  }, [offset]);

  useEffect(() => {
    const getChatChannelId = id?.startsWith("id=") ? id.replace("id=", "") : id;
    const isValidChannelId =
      getChatChannelId &&
      getChatChannelId !== "null" &&
      getChatChannelId !== "undefined";
    setChatChannelID(isValidChannelId ? getChatChannelId : null);
    setSelectedChannelID(isValidChannelId ? getChatChannelId : null);
  }, [id]);

  const handleIntersection = useCallback(
    debounce((entries) => {
      if (entries[0].isIntersecting && hasMore && !isLoadingMore) {
        setIsLoadingMore(true);
        setOffset((prev) => prev + 10);
      }
    }, 200),
    [hasMore, isLoadingMore],
  );

  const lastElement = useCallback(
    (node) => {
      if (isLoading || !hasMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        handleIntersection(entries);
      });
      if (node) observer.current.observe(node);
    },
    [handleIntersection, isLoading, hasMore],
  );

  const handleMouseEnter = (channelID) => {
    setHoveredChannel(channelID);
  };

  const handleMouseLeave = () => {
    setHoveredChannel(null);
  };

  const handleSelectDeleteChannel = (channelID) => {
    setDeleteChannelID(channelID);
    setOpenDeleteDialog(true);
    const selectedChannel = chatChannelsList.find(
      (channel) => channel.ID === channelID,
    );
    if (selectedChannel) {
      const formattedTitle = selectedChannel.Title
        ? selectedChannel.Title.replace(/^(Candidate|Job): /, "")
        : "Untitled Chat";
      setSelectedChannelInitialContent(formattedTitle);
    }
  };

  const handleDeleteChannel = async (channelID) => {
    try {
      await deleteRequest(
        VYLABS_BASE_URL,
        `${DELETE_CHAT_CHANNEL_URL}?channelID=${channelID}`,
      );
      Toast("success", "Chat channel deleted successfully.");
      await fetchChannels(true);
      if (selectedChannelID === channelID) {
        setSelectedChannelID(null);
        setChatChannelID(null);
        setMessages([]);
        setChatMessages([]);
        setmessageOffset(0);
        setmessageHasMore(true);
        setIsMessagesLoading(false);
        navigate(`/conversations`);
      }
    } catch (err) {
      console.error("Error deleting chat channel:", err);
      Toast("error", "Failed to delete chat channel.");
    } finally {
      setOpenDeleteDialog(false);
    }
  };

  const groupedData = groupByDateCategory(chatChannelsList);

  const getCurrentChatType = () => {
    const selectedChannel = chatChannelsList.find(
      (c) => c.ID === selectedChannelID,
    );
    return selectedChannel?.ChatChannelType || chatType || "candidate";
  };

  const renderChatMessages = () => {
    return (
      <div className="messages-container">
        {getCurrentChatType() === "candidate" && topCandidates.length > 0 && (
          <div className="top-candidates-grid">
            {topCandidates.map((candidate, index) => (
              <Card
                key={candidate.id || `resume-${index}`}
                name={
                  candidate.name ||
                  candidate.parsed_resume?.BasicInfo?.Name ||
                  "N/A"
                }
                email={
                  candidate.email ||
                  candidate.parsed_resume?.BasicInfo?.Email ||
                  "N/A"
                }
                phone={
                  candidate.phone ||
                  candidate.parsed_resume?.BasicInfo?.PhoneNumber ||
                  "N/A"
                }
                location={
                  candidate.city ||
                  candidate.parsed_resume?.BasicInfo?.CurrentLocationCity ||
                  "N/A"
                }
                role={
                  candidate.designation && candidate.designation.trim() !== ""
                    ? candidate.designation
                    : candidate.parsedResumeData?.CareerHistory?.JobDetails?.[0]
                          ?.JobTitle
                      ? candidate.parsedResumeData.CareerHistory.JobDetails[0]
                          .JobTitle
                      : "Not specified"
                }
                experience={
                  candidate.parsed_resume?.BasicInfo?.YearsOfExperience ||
                  candidate.experience ||
                  "N/A"
                }
                skills={
                  candidate.parsed_resume?.Skills || candidate.skills || []
                }
                cardbackgroundColor="var(--body__background)"
                cardColor="black"
                skillbackgroundColor="#E0DEFF"
                skillColor="#2D23DB"
                viewEvent={(e) => {
                  e.stopPropagation();
                  handleCardView(candidate, e);
                }}
              />
            ))}
          </div>
        )}

        {getCurrentChatType() === "job" && topJobs.length > 0 && (
          <div className="top-jobs-grid">
            {topJobs.map((job, index) => (
              <JobsCard
                key={index}
                jobId={job.id}
                title={job.title}
                role={job.job_role || job.title}
                experience={job.years_experience}
                jobtype={job.job_type}
                client={job?.client?.name}
                jobRole={job?.job_role}
                actionText={true}
                skills={job.skills || []}
                minSalary={job.salary_min}
                maxSalary={job.salary_max}
                tags={job.tags || []}
                location={job.location}
                client_contact_person={
                  job?.client_contact
                    ? job?.client_contact?.name
                    : job?.client?.contact_person
                }
                cardbackgroundColor="linear-gradient(rgb(66 185 120 / 31%), #D6FFE8)"
                cardColor="rgb(8 104 29)"
                skillbackgroundColor="rgb(12 122 51 / 74%)"
                skillColor="#fff"
                isActive={job.active}
                icon={job.icon}
                showEditIcon={false}
                viewJobEventHandler={(e) => {
                  e.stopPropagation();
                  handleOpenJobsSideContainer(job, index, "Job Details");
                }}
                assignCandidateEventHandler={(e) => {
                  e.stopPropagation();
                  handleOpenJobsSideContainer(
                    job,
                    index,
                    "Assigned Candidates",
                  );
                }}
              />
            ))}
          </div>
        )}

        {messages.map((message, index) => (
          <div key={index} className={`message-wrapper ${message.sender}`}>
            {message.sender === "user" ? (
              <div className="user-message-container">
                <div className="user-message-content">
                  <p className="user-message-query-text">{message.text}</p>
                  {message.files && message.files.length > 0 && (
                    <div className="uploaded-files">
                      {message.files.map((file, fileIndex) => (
                        <span key={fileIndex}>{file.name}</span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              renderBotResponse(message)
            )}
          </div>
        ))}
      </div>
    );
  };

  const renderGroupedChatChannels = (groupedChannels) => {
    const isBlocked = isUIBlocked;
    const categoryOrder = [
      "Today",
      "Yesterday",
      "Previous 7 Days",
      "Previous 30 Days",
      "Older",
    ];
    return categoryOrder.map((groupName) => {
      const channels = groupedChannels[groupName];
      if (!channels || channels.length === 0) return null;
      const filteredChannels = channels.filter((channel) =>
        channel.ID.toLowerCase().includes(searchChannel.toLowerCase()),
      );
      if (filteredChannels.length === 0) return null;
      return (
        <div key={groupName} className="chat-group">
          <h4 className="chat-group-title">{groupName}</h4>
          {filteredChannels.map((channel, index) => (
            <div
              key={index}
              onClick={() => {
                if (!isBlocked) {
                  handleChannelClick(channel.ID);
                }
              }}
              onMouseEnter={() => {
                if (!isBlocked) {
                  handleMouseEnter(channel.ID);
                }
              }}
              onMouseLeave={handleMouseLeave}
              className={`inner-chat-channels-list ${
                selectedChannelID === channel.ID
                  ? "selected-channel-container"
                  : "channel-container"
              }`}
              style={isBlocked ? { pointerEvents: "none", opacity: 0.7 } : {}}
              ref={index === filteredChannels.length - 1 ? lastElement : null}
            >
              <div className="channel-title">
                {channel?.ChatChannelType === "candidate" ? (
                  <img src={CandidateConvoIcon} alt="CandidateConvoIcon" />
                ) : (
                  <img src={JobConvoIcon} alt="JobConvoIcon" />
                )}
                <span className="channel-title-text">
                  {channel?.Title === null
                    ? `Chat -${index + 1}`
                    : channel.Title.replace(/^(Candidate|Job): /, "")}
                </span>
                {hoveredChannel === channel.ID && (
                  <div className="delete-icon">
                    <Menuselector
                      options={popupItems}
                      onSelect={(item) => handleSelect(item, index, channel.ID)}
                      onOpen={openDropDownMenu}
                      onClose={() => setOpenDropDownMenu(false)}
                      rowIndex={index}
                      menuStyle={{
                        "& .MuiPaper-root": {
                          width: "200px",
                          left: "calc(100% - 230px) !important",
                        },
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      );
    });
  };

  const fetchResumesList = useCallback(
    async (candidateIds = [], botMessageId) => {
      const detailedCandidates = await Promise.all(
        candidateIds.map(async (candidateId) => {
          try {
            const res = await get(
              VYLABS_BASE_URL,
              `${GET_CANDIDATE_BY_ID}?id=${candidateId}`,
            );
            return {
              ...res.candidate,
              parsed_resume: res.candidate.parsed_resume
                ? JSON.parse(res.candidate.parsed_resume)
                : null,
              isFileBased: false,
            };
          } catch (err) {
            console.error(`Error fetching candidate ${candidateId}:`, err);
            return null;
          }
        }),
      );
      const filteredCandidates = detailedCandidates.filter(Boolean);

      setMessages((prev) => {
        const updated = [...prev];
        const botMessageIndex = updated.findIndex(
          (msg) => msg.id === botMessageId && msg.sender === "bot",
        );

        if (botMessageIndex !== -1) {
          updated[botMessageIndex] = {
            ...updated[botMessageIndex],
            isLoading: false,
            resumes: filteredCandidates,
          };
        }

        return updated;
      });
      if (getCurrentChatType() === "candidate") {
        setTopCandidates(filteredCandidates);
      }
      setIsBotProcessing(false);
    },
    [],
  );

  const fetchChannels = useCallback(
    async (forceRefresh = false, forcedOffset = null) => {
      if (isLoading) return;
      setIsLoading(true);
      const currentOffset =
        forcedOffset !== null ? forcedOffset : offsetRef.current;
      try {
        const response = await get(
          VYLABS_BASE_URL,
          `${GET_CHAT_CHANNEL_LIST_URL}?offset=${currentOffset}&limit=10`,
        );
        const chat_channels = response?.chat_channels || [];
        setChatChannelsList((prev) => {
          if (forceRefresh || currentOffset === 0) {
            return chat_channels;
          } else {
            const existingIds = new Set(prev.map((channel) => channel.ID));
            const newChannels = chat_channels.filter(
              (channel) => !existingIds.has(channel.ID),
            );
            return [...prev, ...newChannels];
          }
        });
        setHasMore(chat_channels.length === 10);
      } catch (err) {
        console.error("GET_CHAT_CHANNEL_LIST_URL error", err);
        setHasMore(false);
      } finally {
        setIsLoading(false);
        setIsLoadingMore(false);
      }
    },
    [],
  );

  useEffect(() => {
    fetchChannels();
  }, [offset, fetchChannels]);

  useEffect(() => {
    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []);

  const formik = useFormik({
    initialValues: {
      jobDescription: searchData?.clearInputs
        ? ""
        : searchData?.jobDescription || "",
      askmeanything: searchData?.clearInputs
        ? ""
        : searchData?.askmeanything || "",
    },
  });

  const jobFormik = useFormik({
    initialValues: {
      yearsOfExperience: "",
      jobLocation: "",
      salary_min: "",
      salary_max: "",
      jobType: "",
      openings: "",
      title: "",
      jobRole: "",
      jobDescription: "",
      skills: "",
      tags: "",
      clientID: "",
    },
    onSubmit: () => {},
  });

  if (
    AiDrivenUploadedFiles.length > 0 &&
    !(AiDrivenUploadedFiles[0] instanceof File)
  ) {
    setAiDrivenUploadedFiles([]);
  }

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  useEffect(() => {
    if (searchData) {
      setIsInitializing(true);
      setIsFromNavigation(true);
      if (searchData.uploadedFiles?.length > 0) {
        setAiDrivenUploadedFiles([...searchData.uploadedFiles]);
      }
      if (searchData.jobDescription) {
        formik.setFieldValue("jobDescription", searchData.jobDescription);
      }
      if (searchData.askmeanything) {
        formik.setFieldValue("askmeanything", searchData.askmeanything);
      }
      setIsInitializing(false);
    } else {
      setIsInitializing(false);
    }
  }, [searchData]);

  const handleSearchForCandidates = useCallback(
    async (e) => {
      if (e) e.preventDefault();
      const { jobDescription, askmeanything } = formik.values;
      const hasJobDescription = jobDescription?.trim();
      const hasUserQuery = askmeanything?.trim();
      const hasUploadedFiles = AiDrivenUploadedFiles.length > 0;

      if (!hasJobDescription && !hasUserQuery && !hasUploadedFiles) {
        Toast("error", "Please fill any one of these search field values.");
        return;
      }

      setIsInitializing(true);
      setIsCreatingChannel(true);
      setIsBotProcessing(true);
      const userMessageText = hasUserQuery
        ? askmeanything.trim()
        : hasJobDescription
          ? jobDescription.trim()
          : "File uploaded";

      const messageId = Date.now();
      const botPlaceholderId = messageId + 1;

      setMessages([
        {
          id: messageId,
          sender: "user",
          text: userMessageText,
          files: hasUploadedFiles ? [...AiDrivenUploadedFiles] : [],
        },
        { id: botPlaceholderId, sender: "bot", text: "", isLoading: true },
      ]);

      try {
        const createChatChannelResponse = await post(
          VYLABS_BASE_URL,
          CREATE_CHAT_CHANNEL_URL,
          { chat_channel_type: "candidate" },
        );
        const channelID = createChatChannelResponse.ID;
        setChatChannelID(channelID);
        setSelectedChannelID(channelID);
        navigate(`/conversation/id=${channelID}`, {
          state: { searchData: null },
        });
        await post(VYLABS_BASE_URL, GET_CURRENT_CONVERSATION_TITLE, {
          chat_channel_id: channelID,
          message: userMessageText,
        });
        setIsBotProcessing(false);
        initializeWebSocket();
        await fetchChannels(true);
      } catch (error) {
        console.error("API call failed", error);
        setMessages((prev) => [
          ...prev.filter((msg) => msg.id !== botPlaceholderId),
          {
            id: botPlaceholderId,
            sender: "system",
            text: "Error processing request. Please try again.",
            isLoading: false,
          },
        ]);
        setIsBotProcessing(false);
      } finally {
        setIsCreatingChannel(false);
        setIsInitializing(false);
        formik.resetForm();
        setAiDrivenUploadedFiles([]);
      }
    },
    [
      formik,
      AiDrivenUploadedFiles,
      navigate,
      fetchChannels,
      initializeWebSocket,
    ],
  );

  useEffect(() => {
    if (
      isFromNavigation &&
      !hasTriggered.current &&
      (formik.values.jobDescription ||
        formik.values.askmeanything ||
        AiDrivenUploadedFiles.length > 0)
    ) {
      console.log("Triggering handleSearchForCandidates from navigation");
      hasTriggered.current = true;
      handleSearchForCandidates();
      setIsFromNavigation(false);
    }
  }, [
    isFromNavigation,
    formik.values.jobDescription,
    formik.values.askmeanything,
    AiDrivenUploadedFiles,
    handleSearchForCandidates,
  ]);

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      const newFile = files[0];
      setAiDrivenUploadedFiles([newFile]);
    }
  };

  const formatFileSize = (sizeInBytes) => {
    if (sizeInBytes < 1024) return `${sizeInBytes} bytes`;
    else if (sizeInBytes < 1048576)
      return `${(sizeInBytes / 1024).toFixed(2)} KB`;
    else return `${(sizeInBytes / 1048576).toFixed(2)} MB`;
  };

  const handleFileDelete = (fileName) => {
    setAiDrivenUploadedFiles((prev) =>
      prev.filter((file) => file.name !== fileName),
    );
  };

  const toggleContainer = () => {
    setIsContainerExpanded((prev) => !prev);
  };

  const fetchRecommendedCandidates = useCallback(async (jobId) => {
    try {
      const jobRes = await get(
        VYLABS_BASE_URL,
        `${GET_JOB_DETAILS_BY_ID}?id=${jobId}`,
      );
      const job = jobRes?.job;
      const skillsStr = Array.isArray(job.skills)
        ? job.skills.join(" ")
        : typeof job.skills === "string"
          ? job.skills
          : "";
      `${job.title || ""} ${job.description || ""} ${skillsStr} ${
        job.location || ""
      }`.trim();
    } catch (err) {
      console.error("Error fetching recommended candidates:", err);
      return [];
    }
  }, []);
  const handleOpenJobsSideContainer = (job, index, tab) => {
    setIsFromCandidateRecommendedJobs(true);
    setSelectedJob({ ...job, index });
    setJobsSideContainerOpen(true);
    setJobActiveTab(tab);
    fetchRecommendedCandidates(job.id);
  };

  const handleCloseJobsSideContainer = () => {
    setIsFromCandidateRecommendedJobs(false);
    setJobsSideContainerOpen(false);
    setSelectedJob(null);
    setJobActiveTab("Job Details");
    setIsEditingJob(false);
    setOriginalJobData(null);
    setEditedJobData(null);
  };

  const handleEditJob = () => {
    setOriginalJobData({ ...selectedJob });
    setEditedJobData({ ...selectedJob });
    jobFormik.setValues({
      title: selectedJob.title || "",
      jobRole: selectedJob.job_role || "",
      jobDescription: selectedJob.description || "",
      skills: selectedJob.skills || [],
      tags: selectedJob.tags || [],
      clientID: selectedJob.client_id || "",
      yearsOfExperience: selectedJob.years_experience?.toString() || "",
      jobLocation: selectedJob.location || "",
      salary_min: selectedJob.salary_min?.toString() || "",
      salary_max: selectedJob.salary_max?.toString() || "",
      jobType: selectedJob.job_type || "",
      openings: selectedJob.openings?.toString() || "",
    });
    setIsEditingJob(true);
  };

  const saveJobChanges = async () => {
    if (!editedJobData) {
      Toast("error", "No changes to save");
      return;
    }

    try {
      const fieldMap = {
        years_experience: "jobYearsExperience",
        salary_min: "jobSalaryMin",
        salary_max: "jobSalaryMax",
        openings: "jobOpenings",
        job_type: "jobType",
        location: "jobLocation",
      };

      const numericFields = [
        "years_experience",
        "salary_min",
        "salary_max",
        "openings",
      ];

      let changes = {};

      for (const key in editedJobData) {
        const mappedKey = fieldMap[key] || key;

        const oldValue = originalJobData
          ? originalJobData[mappedKey]
          : selectedJob[mappedKey];

        const newValue = numericFields.includes(key)
          ? Number(editedJobData[key] || 0)
          : editedJobData[key];

        if (newValue !== oldValue) {
          changes[mappedKey] = newValue;
        }
      }

      if (Object.keys(changes).length === 0) {
        Toast("info", "No changes detected to save.");
        setIsEditingJob(false);
        return;
      }
      const combinedData = {
        ...editedJobData,
        ...jobFormik.values,
      };

      const jobData = {
        jobID: selectedJob.id,
        jobTitle: combinedData.title,
        jobRole: combinedData.job_role,
        jobDescription: combinedData.description,
        jobSkills: Array.isArray(combinedData.skills)
          ? combinedData.skills.join(", ")
          : combinedData.skills || "",
        jobTags: Array.isArray(combinedData.tags)
          ? combinedData.tags.join(", ")
          : combinedData.tags || "",
        jobType: combinedData.jobType,
        jobYearsExperience: Number(combinedData.yearsOfExperience || 0),
        jobSalaryMin: Number(combinedData.salary_min || 0),
        jobSalaryMax: Number(combinedData.salary_max || 0),
        jobLocation: combinedData.jobLocation,
        jobOpenings: Number(combinedData.openings || 0),
      };

      const response = await put(VYLABS_BASE_URL, UPDATE_JOB, jobData);

      if (response) {
        try {
          const fresh = await get(
            VYLABS_BASE_URL,
            `${GET_JOB_DETAILS_BY_ID}?id=${selectedJob.id}`,
          );
          const freshJob = fresh?.job || null;
          if (freshJob) {
            setSelectedJob(freshJob);
            setTopJobs((prev) =>
              prev.map((job) => (job.id === freshJob.id ? freshJob : job)),
            );
            setChatChannelsList((prev) =>
              prev.map((channel) =>
                channel.ID === selectedChannelID
                  ? { ...channel, Title: `Job: ${freshJob.title}` }
                  : channel,
              ),
            );
            Toast("success", "Job updated successfully");
          } else {
            const updatedJob = { ...selectedJob, ...jobData };
            setSelectedJob(updatedJob);
            setTopJobs((prev) =>
              prev.map((job) => (job.id === updatedJob.id ? updatedJob : job)),
            );
            Toast("success", "Job updated successfully (UI refreshed locally)");
          }
          setIsEditingJob(false);
          setOriginalJobData(null);
          setEditedJobData(null);
        } catch (err) {
          console.error("Error fetching updated job:", err);
          Toast("success", "Job updated, refresh to view latest changes");
          setIsEditingJob(false);
          setOriginalJobData(null);
          setEditedJobData(null);
        }
      }
    } catch (error) {
      console.error("Error updating job:", error);
      Toast("error", "Failed to update job");
    }
  };

  const fetchCandidateById = useCallback(async (id, returnData = false) => {
    try {
      const res = await get(VYLABS_BASE_URL, `${GET_CANDIDATE_BY_ID}?id=${id}`);
      const candidate = res?.candidate;
      const candidatefiles = res?.files;
      const parsedResumeData = candidate?.parsed_resume
        ? JSON.parse(candidate.parsed_resume)
        : null;
      const presignedUrl =
        candidatefiles && candidatefiles.length > 0
          ? candidatefiles[0].presigned_url
          : null;

      const updatedCandidate = {
        ...candidate,
        secondaryEmail: candidate.secondary_email,
        secondaryPhone: candidate.secondary_phone,
        vendorID: candidate.vendor_id,
        lineAddress1: candidate.line_address_1,
        lineAddress2: candidate.line_address_2,
        preferredSalary: candidate.preferred_salary,
        zipCode: candidate.zip_code,
        parsedResumeData,
        files: candidatefiles || null,
        presignedUrl,
        isFileBased: false,
        avatar: res?.profile_img_url,
      };
      if (updatedCandidate.vendorID) {
        try {
          const vendorResponse = await get(
            VYLABS_BASE_URL,
            `${GET_VENDOR_DETAILS_BY_ID}?id=${updatedCandidate.vendorID}`,
          );
          setAssignedVendor(vendorResponse);
          updatedCandidate.vendorDetails = vendorResponse?.vendor || null;
        } catch (err) {
          console.error("Error fetching vendor details:", err);
          updatedCandidate.vendorDetails = null;
        }
      } else {
        updatedCandidate.vendorDetails = null;
      }
      if (returnData) {
        return updatedCandidate;
      } else {
        setSelectedCandidate(updatedCandidate);
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error("Error fetching candidate:", error);
      Toast("error", error.response.data || "Failed to fetch candidate details.");
      setIsModalOpen(false);
      throw error;
    }
  }, []);
  const fetchRecommendedJobs = useCallback(async (candidateId) => {
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${RECOMMEND_JOBS}?candidate_id=${candidateId}`,
      );
      return response || [];
    } catch (error) {
      console.error("Error fetching recommended jobs:", error);
      return [];
    }
  }, []);
  const fetchJobDetailsById = useCallback(async (jobId) => {
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_JOB_DETAILS_BY_ID}?id=${jobId}`,
      );
      return response?.job || null;
    } catch (error) {
      console.error("Error fetching job details for ID", jobId, ":", error);
      return null;
    }
  }, []);

  const handleEditCandidate = () => {
    const getValidExperience = (value) => {
      const num = Number(value);

      if (isNaN(num)) return "";
      if (num < 0) return 0;
      return num;
    };

    let experienceValue = "";
    const directExp = getValidExperience(
      selectedCandidate?.years_of_experience,
    );

    const parsedExp = getValidExperience(
      selectedCandidate?.parsedResumeData?.BasicInfo?.YearsOfExperience,
    );

    if (directExp !== "") {
      experienceValue = directExp;
    } else if (parsedExp !== "") {
      experienceValue = parsedExp;
    }
    const candidateWithFormattedSkills = {
      ...selectedCandidate,
      name:
        selectedCandidate.name ||
        selectedCandidate.parsedResumeData?.BasicInfo?.Name ||
        "",
      email:
        selectedCandidate.email ||
        selectedCandidate.parsedResumeData?.BasicInfo?.Email ||
        "",
      secondaryEmail:
        selectedCandidate.secondaryEmail ||
        selectedCandidate.parsedResumeData?.BasicInfo?.secondaryEmail ||
        "",
      phone:
        selectedCandidate.phone ||
        selectedCandidate.parsedResumeData?.BasicInfo?.PhoneNumber ||
        "",
      lineAddress1:
        selectedCandidate.lineAddress1 ||
        selectedCandidate.parsedResumeData?.BasicInfo?.lineAddress1 ||
        "",
      lineAddress2:
        selectedCandidate.lineAddress2 ||
        selectedCandidate.parsedResumeData?.BasicInfo?.lineAddress2 ||
        "",
      preferredSalary:
        selectedCandidate.preferredSalary ||
        selectedCandidate.parsedResumeData?.BasicInfo?.preferredSalary ||
        "",
      zipCode:
        selectedCandidate.zipCode ||
        selectedCandidate.parsedResumeData?.BasicInfo?.zipCode ||
        "",
      secondaryPhone:
        selectedCandidate.secondaryPhone ||
        selectedCandidate.parsedResumeData?.BasicInfo?.secondaryPhone ||
        "",
      city:
        selectedCandidate.city ||
        selectedCandidate.parsedResumeData?.BasicInfo?.CurrentLocationCity ||
        "",
      state:
        selectedCandidate.state ||
        selectedCandidate.parsedResumeData?.BasicInfo?.CurrentLocationState ||
        "",
      country:
        selectedCandidate.country ||
        selectedCandidate.parsedResumeData?.BasicInfo?.CurrentLocationCountry ||
        "",
      skills: Array.isArray(selectedCandidate.skills)
        ? selectedCandidate.skills
        : selectedCandidate.parsedResumeData?.Skills || [],
      vendorID:
        selectedCandidate.vendorID ||
        selectedCandidate.parsedResumeData?.BasicInfo?.vendorID ||
        "",
      designation:
        selectedCandidate.designation?.trim() ||
        selectedCandidate.parsedResumeData?.CareerHistory?.JobDetails?.[0]
          ?.JobTitle ||
        "",
      experience: experienceValue,
    };

    setOriginalCandidateData({ ...selectedCandidate });
    setEditedCandidateData(candidateWithFormattedSkills);
    setIsEditingCandidate(true);
    setEmailError("");
    setEmailTouched(false);
  };

  const saveCandidateChanges = async () => {
    if (!editedCandidateData) {
      Toast("error", "No changes to save");
      return;
    }

    const email =
      editedCandidateData.email !== undefined
        ? editedCandidateData.email
        : selectedCandidate.email || "";
    if (!email.trim()) {
      setEmailError("Email is required");
      setEmailTouched(true);
      Toast("error", "Email is required");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Invalid email format");
      setEmailTouched(true);
      Toast("error", "Please fill all required fields correctly");
      return;
    }

    setEmailError("");
    setEmailTouched(false);

    try {
      const candidateData = { id: selectedCandidate.id };

      Object.keys(editedCandidateData).forEach((key) => {
        const newValue = editedCandidateData[key];
        const oldValue = selectedCandidate[key];

        const isChanged = Array.isArray(newValue)
          ? JSON.stringify(newValue) !== JSON.stringify(oldValue)
          : newValue !== oldValue;

        if (
          isChanged &&
          newValue !== undefined &&
          newValue !== null &&
          newValue !== ""
        ) {
          candidateData[key] = newValue;
        }
      });

      if (Object.keys(candidateData).length === 1) {
        Toast("error", "No changes to save");
        return;
      }

      Object.keys(candidateData).forEach((key) => {
        if (key === "preferredSalary") {
          candidateData[key] = Number(candidateData[key]);
        }
      });

      if (candidateData.experience !== undefined) {
        candidateData.yearsOfExperience = Number(candidateData.experience);
        delete candidateData.experience;
      }

      const response = await post(
        VYLABS_BASE_URL,
        UPDATE_CANDIDATE_DETAILS,
        candidateData,
      );

      if (response) {
        const updatedCandidate = {
          ...selectedCandidate,
          ...candidateData,
        };

        if (
          candidateData.vendorID !== undefined &&
          candidateData.vendorID !== selectedCandidate.vendorID
        ) {
          if (candidateData.vendorID) {
            try {
              const vendorResponse = await get(
                VYLABS_BASE_URL,
                `${GET_VENDOR_DETAILS_BY_ID}?id=${candidateData.vendorID}`,
              );
              updatedCandidate.vendorDetails = vendorResponse?.vendor || null;
              setAssignedVendor(vendorResponse);
            } catch (err) {
              console.error("Error fetching vendor details:", err);
              updatedCandidate.vendorDetails = null;
              setAssignedVendor(null);
            }
          } else {
            updatedCandidate.vendorDetails = null;
          }
        }

        setSelectedCandidate(updatedCandidate);
        setIsEditingCandidate(false);
        setOriginalCandidateData(null);
        setEditedCandidateData(null);
        Toast("success", "Candidate updated successfully");

        if (isAllCandidatesActive) {
          setAllCanList((prev) =>
            prev.map((candidate) =>
              candidate.id === updatedCandidate.id
                ? updatedCandidate
                : candidate,
            ),
          );
        } else {
          setMyCanList((prev) =>
            prev.map((candidate) =>
              candidate.id === updatedCandidate.id
                ? updatedCandidate
                : candidate,
            ),
          );
        }
      }
    } catch (error) {
      console.error("Error updating candidate:", error);
      const backendMessage =
        error?.response?.data?.message ||
        (typeof error?.response?.data === "string"
          ? error.response.data
          : null) ||
        error.message ||
        "Failed to update candidate";
      Toast("error", backendMessage);
    }
  };

  const handleCardView = useCallback(
    async (candidate, e) => {
      e.stopPropagation();
      try {
        if (!candidate.isFileBased && candidate.id) {
          const candidateDetails = await fetchCandidateById(candidate.id, true);
          candidate = {
            ...candidate,
            ...candidateDetails,
            isFileBased: false,
          };
        }

        const response = await fetchRecommendedJobs(candidate.id);
        const jobIds = response || [];
        const jobDetailPromises = jobIds.map((job) =>
          fetchJobDetailsById(job.id || job.job_id),
        );
        const recommendedJobs = (await Promise.all(jobDetailPromises)).filter(
          Boolean,
        );
        setSelectedCandidate((prev) => ({
          ...prev,
          ...candidate,
          recommendedJobs,
        }));
        setIsModalOpen(true);
      } catch (error) {
        console.error("Error in handleCardView:", error);
        setSelectedCandidate(candidate);
      }
    },
    [fetchCandidateById, fetchRecommendedJobs, fetchJobDetailsById],
  );

  const renderBotResponse = (message, index) => {
    if (message.sender !== "bot") return null;
    const currentChatType = getCurrentChatType();

    let candidates = [];
    let jobs = [];
    let messageText = message.text;
    if (
      message.jobs &&
      Array.isArray(message.jobs) &&
      message.jobs.length > 0
    ) {
      if (currentChatType === "job") {
        jobs = message.jobs;
      }
    }
    if (message.Content) {
      try {
        const content = JSON.parse(message.Content);
        messageText = content.answer || message.text || "";
      } catch (error) {
        messageText = message.text || "";
      }
    }

    const { summary, skillsLines, educationLines } =
      parseMessageText(messageText);

    if (currentChatType === "candidate" && message.resumes?.length > 0) {
      if (!summary || (!skillsLines.length && !educationLines.length)) {
        return null;
      }
      const lowerSummary = summary.toLowerCase().trim();
      const isGenericOnly =
        lowerSummary.includes("matching candidates") ||
        lowerSummary.includes("here are");
      if (isGenericOnly && !skillsLines.length && !educationLines.length) {
        return null;
      }
    }

    if (currentChatType === "job" && message.resumes?.length > 0) {
      if (!summary || (!skillsLines.length && !educationLines.length)) {
        return null;
      }
      const lowerSummary = summary.toLowerCase().trim();
      const isGenericOnly =
        lowerSummary.includes("matching jobs") ||
        lowerSummary.includes("here are");
      if (isGenericOnly && !skillsLines.length && !educationLines.length) {
        return null;
      }
    }

    return (
      <div className="aidriven-bot-response-container" key={index}>
        <img
          src={BotReplyIcon}
          alt="BotReplyIcon"
          className="bot-replay-icon"
        />
        <div
          className="bot-response"
          style={
            message.isLoading
              ? { border: "none" }
              : { border: "1px solid var(--border__color)" }
          }
        >
          <div className="bot-message">
            <div className="reply-message">
              {isBotProcessing && message.isLoading ? (
                <ThinkingBubble />
              ) : (
                <div className="text-with-card-container">
                  {summary && (
                    <div className="summary-container">
                      {summary.split("\n").map((line, idx) => {
                        const trimmedLine = line.trim();
                        const bulletContent = getBulletContent(trimmedLine);
                        if (bulletContent !== null) {
                          return (
                            <div
                              key={idx}
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                marginBottom: "5px",
                              }}
                            >
                              <img
                                src={BotResponseStarIcon}
                                alt="bullet"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  marginRight: "8px",
                                  marginTop: "10px",
                                  flexShrink: 0,
                                }}
                              />
                              <span
                                className="summary-text"
                                style={{ whiteSpace: "pre-wrap" }}
                              >
                                {renderInlineMarkdown(bulletContent)}
                              </span>
                            </div>
                          );
                        }
                        return (
                          <p
                            key={idx}
                            className="summary-text"
                            style={{
                              whiteSpace: "pre-wrap",
                              marginBottom: "5px",
                              marginTop: "0px",
                              minHeight: line.trim() ? "auto" : "1em",
                            }}
                          >
                            {renderBotContent(line)}
                          </p>
                        );
                      })}
                    </div>
                  )}

                  {educationLines.length > 0 && (
                    <div className="education-container">
                      <h4 className="education-title">Education Details</h4>
                      {educationLines.map((edu, idx) => (
                        <div
                          key={idx}
                          className="education-item"
                          style={{ marginBottom: "10px" }}
                        >
                          <h5 style={{ fontWeight: "bold", margin: "5px 0" }}>
                            {edu.degree}
                          </h5>
                          {edu.details.map((detail, detailIdx) => (
                            <p key={detailIdx} style={{ margin: "2px 0" }}>
                              <span style={{ fontWeight: "500" }}>
                                {detail.key}:
                              </span>{" "}
                              {detail.value}
                            </p>
                          ))}
                        </div>
                      ))}
                    </div>
                  )}
                  {currentChatType === "job" && jobs.length > 0 && (
                    <div className="ai-driven-jobs-grid">
                      {jobs.map((job, idx) => (
                        <div className="job-card-wrapper" key={idx + "_outer"}>
                          <JobsCard
                            key={idx}
                            jobId={job.id}
                            title={job.title}
                            role={job.job_role || job.title}
                            experience={job.years_experience}
                            jobtype={job.job_type}
                            actionText={true}
                            skills={job.skills || []}
                            client={job?.client?.name}
                            jobRole={job?.job_role}
                            minSalary={job.salary_min}
                            maxSalary={job.salary_max}
                            tags={job.tags || []}
                            location={job.location}
                            client_contact_person={
                              job?.client_contact
                                ? job?.client_contact?.name
                                : job?.client?.contact_person
                            }
                            cardbackgroundColor="linear-gradient(rgb(66 185 120 / 31%), #D6FFE8)"
                            cardColor="rgb(8 104 29)"
                            skillbackgroundColor="rgb(12 122 51 / 74%)"
                            skillColor="#fff"
                            isActive={job.active}
                            icon={job.icon}
                            showEditIcon={false}
                            viewJobEventHandler={(e) => {
                              e.stopPropagation();
                              handleOpenJobsSideContainer(
                                job,
                                index,
                                "Job Details",
                              );
                            }}
                            assignCandidateEventHandler={(e) => {
                              e.stopPropagation();
                              handleOpenJobsSideContainer(
                                job,
                                index,
                                "Assigned Candidates",
                              );
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                  {currentChatType === "candidate" && candidates.length > 0 && (
                    <div className="candidates-grid">
                      {candidates.map((candidate, index) => (
                        <Card
                          key={candidate.id || `resume-${index}`}
                          name={
                            candidate.name ||
                            candidate.parsed_resume?.BasicInfo?.Name ||
                            "N/A"
                          }
                          email={
                            candidate.email ||
                            candidate.parsed_resume?.BasicInfo?.Email ||
                            "N/A"
                          }
                          phone={
                            candidate.phone ||
                            candidate.parsed_resume?.BasicInfo?.PhoneNumber ||
                            "N/A"
                          }
                          location={
                            candidate.city ||
                            candidate.parsed_resume?.BasicInfo
                              ?.CurrentLocationCity ||
                            "N/A"
                          }
                          role={
                            candidate.designation &&
                            candidate.designation.trim() !== ""
                              ? candidate.designation
                              : candidate.parsedResumeData?.CareerHistory
                                    ?.JobDetails?.[0]?.JobTitle
                                ? candidate.parsedResumeData.CareerHistory
                                    .JobDetails[0].JobTitle
                                : "Not specified"
                          }
                          experience={
                            candidate.parsed_resume?.BasicInfo
                              ?.YearsOfExperience ||
                            candidate.experience ||
                            "N/A"
                          }
                          skills={
                            candidate.parsed_resume?.Skills ||
                            candidate.skills ||
                            []
                          }
                          cardbackgroundColor="var(--body__background)"
                          cardColor="black"
                          skillbackgroundColor="#E0DEFF"
                          skillColor="#2D23DB"
                          viewEvent={(e) => {
                            e.stopPropagation();
                            handleCardView(candidate, e);
                          }}
                        />
                      ))}
                    </div>
                  )}
                  {message.decorator &&
                    message.decorator.type === "interview_schedule" && (
                      <div className="interview-schedule-container">
                        <div className="interview-schedule-header-container">
                          <h3 className="interview-schedule-header">
                            Interview Schedule
                          </h3>
                          <div className="interview-detail-item">
                            <img
                              src={interviewerIcon}
                              alt="Interviewer"
                              style={{ width: "24px", height: "24px" }}
                            />
                            Interviewer :
                            <p>
                              {`${userDetails?.first_name} ${userDetails?.last_name}` ||
                                "N/A"}
                            </p>
                          </div>
                        </div>

                        <div className="interview-details">
                          <div className="interview-detail-item">
                            <img
                              src={candidateNameIcon}
                              alt="Name"
                              style={{ width: "24px", height: "24px" }}
                            />
                            Name:
                            <p>
                              {message.decorator.candidateDetails?.name ||
                                "N/A"}
                            </p>
                          </div>
                          <div className="interview-detail-item">
                            <img
                              src={candidateEmailIcon}
                              alt="Email"
                              style={{ width: "24px", height: "24px" }}
                            />
                            Email:
                            <p>
                              {message.decorator.candidateDetails?.email ||
                                "N/A"}
                            </p>
                          </div>
                          <div className="interview-detail-item">
                            <img
                              src={calenderIcon}
                              alt="Date"
                              style={{ width: "24px", height: "24px" }}
                            />
                            Date:
                            <p>
                              {message.decorator.parsedEventArgs?.date || "N/A"}
                            </p>
                          </div>
                          <div className="interview-detail-item">
                            <img
                              src={timerIcon}
                              alt="Time"
                              style={{ width: "24px", height: "24px" }}
                            />
                            Time:
                            <p>
                              {message.decorator.parsedEventArgs?.time || "N/A"}
                            </p>
                          </div>
                        </div>

                        <div className="card-interview-button-container">
                          <Button
                            label={"Cancel"}
                            isCancel={true}
                            disabled={isInterviewScheduled(message.id)}
                            event={() => cancelInterview(message.id)}
                            style={{
                              opacity: isInterviewScheduled(message.id)
                                ? 0.6
                                : 1,
                              cursor: isInterviewScheduled(message.id)
                                ? "not-allowed"
                                : "pointer",
                              backgroundColor: isInterviewScheduled(message.id)
                                ? "#f5f5f5"
                                : "",
                              color: isInterviewScheduled(message.id)
                                ? "#a0a0a0"
                                : "",
                            }}
                          />
                          <Button
                            label={
                              isInterviewScheduling(message.id)
                                ? "Scheduling..."
                                : isInterviewScheduled(message.id)
                                  ? "Interview Scheduled"
                                  : "Schedule Interview"
                            }
                            event={() =>
                              scheduleInterview(message.id, message.decorator)
                            }
                            disabled={
                              isInterviewScheduling(message.id) ||
                              isInterviewScheduled(message.id)
                            }
                            style={{
                              opacity:
                                isInterviewScheduling(message.id) ||
                                isInterviewScheduled(message.id)
                                  ? 0.6
                                  : 1,
                              cursor:
                                isInterviewScheduling(message.id) ||
                                isInterviewScheduled(message.id)
                                  ? "not-allowed"
                                  : "pointer",
                              backgroundColor: isInterviewScheduled(message.id)
                                ? "#f5f5f5"
                                : "",
                              color: isInterviewScheduled(message.id)
                                ? "#a0a0a0"
                                : "",
                            }}
                          />
                        </div>
                      </div>
                    )}
                  {skillsLines.length > 0 && (
                    <div className="skills-container">
                      <div className="skills-list">
                        <ul>
                          {skillsLines.map((skill, idx) => (
                            <li key={idx} className="skill-item">
                              {skill}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (chatChannelID && chatChannelID !== "null") {
      fetchMessagesForChannel(chatChannelID, 0);
    }
  }, [chatChannelID]);

  const fetchMessagesForChannel = useCallback(
    async (channelID, offset = 0) => {
      if (!channelID || channelID === "null" || channelID === "undefined") {
        console.warn("Invalid channelID, skipping fetch");
        setMessages([]);
        setChatMessages([]);
        setmessageHasMore(false);
        setIsMessagesLoading(false);
        return;
      }
      if (messageIsLoading) return;
      setmessageIsLoading(true);
      setIsMessagesLoading(true);
      try {
        const response = await get(
          VYLABS_BASE_URL,
          `${GET_CHAT_MESSAGES_LIST_URL}?chatChannelID=${channelID}&offset=${offset}&limit=30`,
        );
        const { chat_messages, has_more } = response || {};
        if (chat_messages && chat_messages.length > 0) {
          const candidateIds = new Set();
          const jobIds = new Set();

          chat_messages.forEach((msg) => {
            if (
              msg.metadata &&
              msg.metadata !== "[]" &&
              msg.metadata !== "{}"
            ) {
              try {
                const metadata = JSON.parse(msg.metadata);
                if (Array.isArray(metadata)) {
                  metadata.forEach((item) => {
                    if (item.candidate_id) candidateIds.add(item.candidate_id);
                    if (item.job_id) jobIds.add(item.job_id);
                  });
                }
              } catch (error) {
                console.error("Error parsing metadata in fetch:", error);
              }
            }
          });

          setConversationContext({
            candidateIds: Array.from(candidateIds),
            jobIds: Array.from(jobIds),
          });
        }

        if (chat_messages && chat_messages.length > 0) {
          const sortedMessages = chat_messages.sort((a, b) => {
            return new Date(a.created_at) - new Date(b.created_at);
          });
          const mappedMessages = await Promise.all(
            sortedMessages.map(async (msg) => {
              let content = msg.content || "";
              let isBotReply = msg.sender_id === channelID;
              let messageText = "";
              let uploadedFiles = [];
              let resumes = [];
              let jobs = [];
              let metadata = [];
              let decorator = null;
              try {
                const parsedContent = JSON.parse(content);
                if (isBotReply) {
                  messageText = parsedContent.answer || "";
                } else {
                  messageText = parsedContent.message || "";
                  if (
                    parsedContent.file_names &&
                    Array.isArray(parsedContent.file_names)
                  ) {
                    uploadedFiles = parsedContent.file_names
                      .filter((fileName) => fileName && fileName.trim() !== "")
                      .map((fileName) => ({ name: fileName }));
                    if (!messageText && uploadedFiles.length > 0) {
                      messageText = "File uploaded";
                    }
                  }
                }
              } catch (e) {
                messageText = content;
              }
              if (isBotReply && msg.decorator && msg.decorator !== "{}") {
                try {
                  decorator = JSON.parse(msg.decorator);
                  if (
                    decorator.event_args &&
                    typeof decorator.event_args === "string"
                  ) {
                    decorator.parsedEventArgs = JSON.parse(
                      decorator.event_args,
                    );
                  }
                } catch (e) {
                  console.error("Error parsing decorator JSON:", e);
                }
              }
              if (
                msg.metadata &&
                msg.metadata !== "{}" &&
                msg.metadata !== "[]"
              ) {
                try {
                  metadata = JSON.parse(msg.metadata);
                  if (Array.isArray(metadata)) {
                    const candidateMetadata = metadata.filter(
                      (item) => item.candidate_id,
                    );
                    const jobMetadata = metadata.filter((item) => item.job_id);
                    if (candidateMetadata.length > 0) {
                      resumes = candidateMetadata
                        .filter((item) => item.name && item.name.trim() !== "")
                        .map((item) => ({
                          id: item.candidate_id,
                          candidate_id: item.candidate_id,
                          name: item.name,
                          email: item.email,
                          phone: item.phone,
                          skills: item.skills,
                          experience: item.years_of_experience,
                          role: item.role,
                          city: item.city,
                          isFileBased: false,
                          parsed_resume: null,
                        }));
                    }
                    if (jobMetadata.length > 0) {
                      const jobDetails = await Promise.all(
                        jobMetadata.map(async (item) => {
                          try {
                            const res = await get(
                              VYLABS_BASE_URL,
                              `${GET_JOB_DETAILS_BY_ID}?id=${item.job_id}`,
                            );
                            return {
                              ...res.job,
                              title: res.job.title,
                              description: res.job.description,
                              skills: res.job.skills
                                ? Array.isArray(res.job.skills)
                                  ? res.job.skills
                                  : res.job.skills
                                      .split(",")
                                      .map((s) => s.trim())
                                : [],
                              job_id: item.job_id,
                            };
                          } catch (err) {
                            console.error(
                              `Error fetching job ${item.job_id}:`,
                              err,
                            );
                            return null;
                          }
                        }),
                      );
                      jobs = jobDetails.filter(Boolean);
                    }
                  }
                } catch (e) {
                  console.error("Error parsing Metadata JSON:", e);
                }
              }
              if (
                decorator &&
                decorator.type === "interview_schedule" &&
                decorator.parsedEventArgs?.candidate_id
              ) {
                try {
                  const res = await get(
                    VYLABS_BASE_URL,
                    `${GET_CANDIDATE_BY_ID}?id=${decorator.parsedEventArgs.candidate_id}`,
                  );
                  decorator.candidateDetails = {
                    id: res.candidate.id,
                    name: res.candidate.name,
                    email: res.candidate.email,
                  };
                } catch (error) {
                  console.error(
                    "Error fetching candidate for interview:",
                    error,
                  );
                  decorator.candidateDetails = { name: "N/A", email: "N/A" };
                }
              }

              if (decorator?.executed) {
                setInterviewStatus(msg.id, {
                  isScheduling: false,
                  isScheduled: true,
                });
              }
              return {
                id: msg.id || Date.now() + Math.random(),
                sender: isBotReply ? "bot" : "user",
                text: messageText,
                files: uploadedFiles,
                resumes: resumes,
                jobs: jobs,
                metadata: metadata,
                decorator: decorator,
                created_at: msg.created_at,
              };
            }),
          );

          setMessages((prev) => {
            const existingIds = new Set(prev.map((msg) => msg.id));
            const newMessages = mappedMessages.filter(
              (msg) => !existingIds.has(msg.id),
            );
            const updatedMessages =
              offset === 0 ? newMessages : [...newMessages, ...prev];
            return updatedMessages.sort(
              (a, b) => new Date(a.created_at) - new Date(b.created_at),
            );
          });
          const allCandidates = [];
          let allJobs = [];
          mappedMessages.forEach((msg) => {
            if (
              msg.resumes &&
              Array.isArray(msg.resumes) &&
              msg.resumes.length > 0
            ) {
              allCandidates.push(...msg.resumes);
            }
          });
          if (mappedMessages.length > 0) {
            const oldestMessage = mappedMessages[0];
            if (
              oldestMessage.metadata &&
              Array.isArray(oldestMessage.metadata) &&
              oldestMessage.metadata.length > 0
            ) {
              const jobMetadata = oldestMessage.metadata.filter(
                (item) => item.job_id,
              );
              if (jobMetadata.length > 0) {
                allJobs = jobMetadata.map((item) => ({
                  id: item.job_id,
                  title: item.title || "N/A",
                  job_role: item.title || "N/A",
                  years_experience: "N/A",
                  job_type: "Contract",
                  skills: [],
                  salary_min: "N/A",
                  salary_max: "N/A",
                  tags: [],
                  location: "N/A",
                  active: true,
                  icon: "",
                }));
              }
            }
          }
          if (allJobs.length > 0 && allJobs.length >= allCandidates.length) {
            setTopJobs(allJobs);
            setTopCandidates([]);
          } else if (
            allCandidates.length > 0 &&
            allCandidates.length >= allJobs.length
          ) {
            setTopCandidates(allCandidates);
            setTopJobs([]);
          } else {
            setTopCandidates([]);
            setTopJobs([]);
          }
          setmessageHasMore(has_more || chat_messages.length === 30);
          setmessageOffset(offset);
        } else {
          if (!isInitialLoad) {
            setMessages([]);
            setChatMessages([]);
          }
          setmessageHasMore(false);
        }
      } catch (err) {
        console.error("Error fetching chat messages:", err);
        Toast("error", "Failed to fetch chat messages.");
        setMessages([]);
        setChatMessages([]);
        setmessageHasMore(false);
      } finally {
        setmessageIsLoading(false);
        setIsMessagesLoading(false);
        if (offset === 0) {
          setIsInitialLoad(false);
        }
      }
    },
    [
      isInitialLoad,
      messageIsLoading,
      setChatMessages,
      setMessages,
      setmessageHasMore,
      setmessageOffset,
      setIsMessagesLoading,
      setIsInitialLoad,
    ],
  );
  const handleNewConversation = useCallback(async () => {
    const { askmeanything } = formik.values;
    const hasUserQuery = askmeanything?.trim();
    const hasUploadedFiles = AiDrivenUploadedFiles.length > 0;
    if (hasUploadedFiles && !hasUserQuery) {
      Toast("error", "Please provide a message along with the file.");
      return;
    } else if (!hasUserQuery && !hasUploadedFiles) {
      Toast("error", "Please provide a message or upload a file.");
      return;
    }
    setIsBotProcessing(true);

    const messageId = uuidv4();
    const botMessageId = uuidv4();
    setMessages((prevMessages) => [
      ...prevMessages,
      {
        id: messageId,
        sender: "user",
        text: hasUserQuery ? askmeanything : "File uploaded",
        files: hasUploadedFiles ? AiDrivenUploadedFiles : [],
      },
      { id: botMessageId, sender: "bot", text: "", isLoading: true },
    ]);

    try {
      let channelID = chatChannelID;
      let isNewChannel = false;

      if (!channelID || channelID === "null" || channelID === "undefined") {
        const createChatChannelResponse = await post(
          VYLABS_BASE_URL,
          CREATE_CHAT_CHANNEL_URL,
          { chat_channel_type: chatType || "candidate" },
        );
        channelID = createChatChannelResponse.ID;
        setChatChannelID(channelID);
        setSelectedChannelID(channelID);
        isNewChannel = true;
        navigate(`/conversation/id=${channelID}`);
      }

      if (isNewChannel) {
        try {
          const titlePayload = {
            chat_channel_id: channelID,
            message: askmeanything,
          };
          if (hasUploadedFiles) {
            titlePayload.file_name = AiDrivenUploadedFiles[0].name;
          }
          await post(
            VYLABS_BASE_URL,
            GET_CURRENT_CONVERSATION_TITLE,
            titlePayload,
          );
          console.log("Conversation title set for channel:", channelID);
        } catch (error) {
          console.error("Error setting conversation title:", error);
          Toast("error", "Failed to set conversation title.");
        }
      }

      const formData = new FormData();
      formData.append("channel_id", channelID);
      formData.append("message_content", askmeanything || "");
      if (hasUploadedFiles) {
        formData.append("file", AiDrivenUploadedFiles[0]);
      }
      const shouldSendContext =
        isNewChannel &&
        searchResultCandidateIds.length > 0 &&
        !sentContextChannelIds.current.has(channelID);

      if (shouldSendContext) {
        formData.append(
          "candidate_id",
          JSON.stringify(searchResultCandidateIds),
        );
      }

      const apiEndpoint =
        chatType === "job"
          ? PROCESS_JOB_CONVERSATION
          : PROCESS_CANDIDATE_CONVERSATION;
      await post(VYLABS_BASE_URL, apiEndpoint, formData);

      if (shouldSendContext) {
        sentContextChannelIds.current.add(channelID);
      }

      initializeWebSocket();
      await fetchChannels(true);
    } catch (error) {
      console.error("Error in conversation:", error);
      setMessages((prev) => {
        const updated = [...prev];
        const loadingIndex = updated.findIndex((msg) => msg.isLoading);
        if (loadingIndex !== -1) {
          updated[loadingIndex] = {
            sender: "system",
            text: "Error processing request. Please try again.",
            isLoading: false,
          };
        }
        return updated;
      });
    } finally {
      formik.resetForm();
      setAiDrivenUploadedFiles([]);
      setChatType(null);
    }
  }, [
    formik,
    AiDrivenUploadedFiles,
    chatChannelID,
    chatType,
    initializeWebSocket,
    navigate,
    fetchChannels,
  ]);

  const handleCandidateConversation = useCallback(async () => {
    const { askmeanything } = formik.values;
    const hasUserQuery = askmeanything?.trim();
    const hasUploadedFiles = AiDrivenUploadedFiles.length > 0;

    if (hasUploadedFiles && !hasUserQuery) {
      Toast("error", "Please provide a message along with the file.");
      return;
    }
    if (!hasUserQuery && !hasUploadedFiles) {
      Toast("error", "Please provide a message or upload a file.");
      return;
    }

    setIsBotProcessing(true);
    const messageId = uuidv4();
    const botPlaceholderId = uuidv4();
    const userMessageText = hasUserQuery
      ? askmeanything
      : hasUploadedFiles
        ? "File uploaded"
        : "";

    setMessages((prevMessages) => [
      ...prevMessages,
      {
        id: messageId,
        sender: "user",
        text: userMessageText,
        files: hasUploadedFiles ? AiDrivenUploadedFiles : [],
      },
      { id: botPlaceholderId, sender: "bot", text: "", isLoading: true },
    ]);

    try {
      const selectedChannel = chatChannelsList.find(
        (channel) => channel.ID === selectedChannelID,
      );
      const currentChatType = selectedChannel?.ChatChannelType || "candidate";
      const formData = new FormData();
      formData.append("channel_id", selectedChannelID);
      formData.append("message_content", askmeanything || "");
      if (hasUploadedFiles) {
        formData.append("file", AiDrivenUploadedFiles[0]);
      }

      const apiEndpoint =
        currentChatType === "job"
          ? PROCESS_JOB_CONVERSATION
          : PROCESS_CANDIDATE_CONVERSATION;

      await post(VYLABS_BASE_URL, apiEndpoint, formData);
      initializeWebSocket();
    } catch (error) {
      console.error("Error in conversation:", error);
      if (
        error.response?.data &&
        error.response.data.includes("chat channel is blocked")
      ) {
        setMessages((prev) =>
          prev.filter(
            (msg) => msg.id !== messageId && msg.id !== botPlaceholderId,
          ),
        );
        const selectedChannel = chatChannelsList.find(
          (channel) => channel.ID === selectedChannelID,
        );
        const currentChatType = selectedChannel?.ChatChannelType || "candidate";
        setOpenConversationLimitPopup(true);
        setChatType(currentChatType);
      } else {
        setMessages((prev) => [
          ...prev,
          {
            sender: "system",
            text: "Error processing request. Please try again.",
            isLoading: false,
          },
        ]);
      }
    } finally {
      formik.resetForm();
      setAiDrivenUploadedFiles([]);
    }
  }, [
    formik,
    AiDrivenUploadedFiles,
    selectedChannelID,
    chatChannelsList,
    initializeWebSocket,
    messages,
    conversationContext,
  ]);
  const handleChannelClick = async (channelID) => {
    if (channelID === selectedChannelID) return;
    setIsMessagesLoading(true);
    setMessages([]);
    setChatMessages([]);
    setAiDrivenUploadedFiles([]);
    setTopCandidates([]);
    setTopJobs([]);
    setConversationContext({ candidateIds: [], jobIds: [] });
    setmessageOffset(0);
    setmessageHasMore(true);
    setIsInitialLoad(true);
    setIsFetchingMore(false);

    if (chatListContainerRef.current) {
      setScrollPosition(chatListContainerRef.current.scrollTop);
    }

    navigate(`/conversation/id=${channelID}`);
    setChatChannelID(channelID);
    setSelectedChannelID(channelID);

    if (socket) {
      socket.close();
      setSocket(null);
    }

    await fetchMessagesForChannel(channelID, 0);
  };
  useEffect(() => {
    if (chatListContainerRef.current && scrollPosition > 0) {
      chatListContainerRef.current.scrollTop = scrollPosition;
    }
  }, [selectedChannelID, scrollPosition]);

  const closeModal = () => {
    setIsModalOpen(false);
    if (isEditingCandidate) {
      setIsEditingCandidate(false);
      setOriginalCandidateData(null);
      setEditedCandidateData(null);
    }
    if (isEditingJob) {
      setIsEditingJob(false);
      setOriginalJobData(null);
      setEditedJobData(null);
    }
    setActiveTab(0);
    setIsEditingCandidate(false);
    setSelectedCandidate(null);
  };

  useEffect(() => {
    if (!isModalOpen) {
      setActiveTab(null);
    }
  }, [isModalOpen]);

  useEffect(() => {
    return () => {
      if (!location.pathname.startsWith("/conversation")) {
        setMessages([]);
        setChatMessages([]);
        setIsMessagesLoading(false);
        setChatType(null);
      }
    };
  }, [location.pathname]);

  useEffect(() => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  }, [messages]);

  const handleBackToConversation = useCallback(() => {
    setMessages([]);
    setChatChannelID(null);
    setAiDrivenUploadedFiles([]);
    formik.resetForm();
    navigate("/conversations");
  }, [formik, navigate]);

  useEffect(() => {
    if (isChatChannelOpen) {
      document.body.classList.remove("chat-list-closed");
    } else {
      document.body.classList.add("chat-list-closed");
    }
  }, [isChatChannelOpen]);

  useEffect(() => {
    if (closeTab) {
      document.body.classList.add("sidebar-closed");
    } else {
      document.body.classList.remove("sidebar-closed");
    }
  }, [closeTab]);

  const isUIBlocked =
    (isMessagesLoading && messages.length === 0) ||
    (!selectedChannelID && (isCreatingChannel || isInitializing));

  return (
    <div
      className={`ai-driven-container${
        isChatChannelOpen ? "" : " chat-list-closed"
      }`}
    >
      <JobStatusUpdatePopup />
      <div className="header-main-container">
        <h3 className="header-channel-title">
          {(() => {
            if (selectedChannelID && selectedChannelID !== "null") {
              const selectedChannel = chatChannelsList.find(
                (channel) => channel.ID === selectedChannelID,
              );
              return selectedChannel?.Title
                ? applyEllipsis(
                    selectedChannel.Title.replace(/^(Candidate|Job): /, ""),
                    100,
                  )
                : "Chat";
            } else {
              return chatType === "candidate"
                ? "Candidate Search"
                : chatType === "job"
                  ? "Job Search"
                  : "New Chat";
            }
          })()}
        </h3>
        <div className="back-to-conversation">
          <Button
            label="Back to Conversations"
            event={handleBackToConversation}
            iconSrc={backArrowIcon}
          />
        </div>
      </div>
      <div
        className="inner-page-outer-container"
        style={chatChannelsList.length > 0 ? { display: "flex" } : {}}
      >
        <div className="chat-outer-container">
          <div className="chat-container">
            {selectedChannelID && selectedChannelID !== "null" ? (
              <div className="messages" ref={messagesContainerRef}>
                {isMessagesLoading && messages.length === 0 ? (
                  <div className="loading-indicator">
                    <VybogTALLoaderAnimation />
                  </div>
                ) : (
                  renderChatMessages()
                )}
              </div>
            ) : !isCreatingChannel && !isInitializing ? (
              <div
                className="ai-driven-search-outercontainer"
                style={
                  isDarkMode
                    ? { backgroundColor: "#26262A" }
                    : { backgroundColor: "#ffffff" }
                }
              >
                {isContainerExpanded ? (
                  <div className="ai-driven-search-container">
                    <div className="ai-driven-header">
                      <img
                        alt=""
                        src={cepheaChatBannerIcon}
                        className="ai-driven-header-icon"
                      ></img>
                      <div className="ai-driven-header-text">
                        <h2 className="ai-driven-header-title">
                          {chatType === "candidate"
                            ? "Candidate Search"
                            : "Job Search"}
                        </h2>
                        <h3 className="ai-driven-header-sub-title">
                          Your recruitment companion
                        </h3>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="ai-driven-expanded-search-outercontainer">
                    <div
                      className="ai-driven-expanded-search-container"
                      style={{
                        backgroundImage: isDarkMode
                          ? `url(${require("../../Assets/Images/resume-upload-dark-background.png")})`
                          : `url(${require("../../Assets/Images/resume-upload-background.png")})`,
                      }}
                    >
                      <div className="ai-driven-expanded-container">
                        <div className="ai-driven-header-expanded-container">
                          <h3 className="ai-driven-header-expanded">
                            Enter job details
                          </h3>
                        </div>
                        <TextArea
                          placeholder="Enter any details about the job you are trying to fill"
                          className="ai-expanded-search-textfield"
                          name="jobDescription"
                          value={formik.values.jobDescription}
                          onChange={formik.handleChange}
                          style={{
                            height: "35px",
                            border: "none",
                            backgroundColor: isDarkMode ? "#26262A" : "#ffffff",
                          }}
                        />
                        <img
                          alt="resize"
                          onClick={toggleContainer}
                          className="resize-small-icon"
                          src={expandIcon}
                          style={{ width: "20px", height: "20px" }}
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div className="dashboard-ai-driven-search-lowercontainer">
                  <div
                    className="uploaded-files-container"
                    style={{ width: "100%" }}
                  >
                    {AiDrivenUploadedFiles.length > 0 && (
                      <div className="create-uploaded-files-items-list">
                        {AiDrivenUploadedFiles.map((file, index) => (
                          <div className="uploaded-filenames" key={index}>
                            <FileIcon fileName={file.name} />
                            <div className="uploaded-file-container">
                              <div className="uploaded-filename">
                                {displayFileName(file.name)}
                              </div>
                              <div className="uploaded-file-size">
                                {formatFileSize(file.size)}
                              </div>
                            </div>
                            <CancelIcon
                              className="ai-close-icon"
                              onClick={() => handleFileDelete(file.name)}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                    <TextArea
                      placeholder="Ask me Anything"
                      name="askmeanything"
                      value={formik.values.askmeanything}
                      onChange={formik.handleChange}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                          e.preventDefault();
                          handleNewConversation();
                        }
                      }}
                      style={{
                        border: "none",
                        margin: "10px 0",
                        height: "70px",
                        padding: "0",
                        color: "var(--header__color)",
                        backgroundColor: isDarkMode ? "#26262A" : "#ffffff",
                      }}
                      containerStyle={{ gap: "0" }}
                    />
                  </div>
                  <div className="attach-container">
                    <label htmlFor="file-upload" className="attach-label">
                      <img
                        alt=""
                        src={isDarkMode ? DarkPaperClip : paperClip}
                        style={{ width: "20px" }}
                      />
                      <div>Attach Resume</div>
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      accept=".pdf,.doc,.docx"
                      onChange={handleFileUpload}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
                <div className="search-button-container">
                  <SparkleButton
                    onClick={(e) => {
                      e.preventDefault();
                      handleNewConversation();
                    }}
                  >
                    Search
                  </SparkleButton>
                </div>
              </div>
            ) : (
              <div className="messages" ref={messagesContainerRef}>
                <div className="loading-indicator">
                  <VybogTALLoaderAnimation />
                </div>
              </div>
            )}
          </div>
          {chatChannelsList.length > 0 &&
            selectedChannelID &&
            selectedChannelID !== "null" && (
              <div className="message-input">
                <div className="message-input-outer">
                  {openJobDescription && (
                    <TextArea
                      placeholder="Enter any details about the job you are trying to fill"
                      className="ai-expanded-search-textfield"
                      name="jobDescription"
                      value={formik.values.jobDescription}
                      onChange={formik.handleChange}
                      style={{
                        height: "40px",
                        backgroundColor: isDarkMode ? "#26262A" : "#ffffff",
                      }}
                    />
                  )}
                  <div className="ai-driven-outer">
                    <div className="ai-driven-search-lowercontainer">
                      <div
                        className="uploaded-files-container"
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <TextArea
                          placeholder="Ask me Anything"
                          name="askmeanything"
                          value={formik.values.askmeanything}
                          onChange={formik.handleChange}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                              e.preventDefault();
                              handleCandidateConversation();
                            }
                          }}
                          disabled={isBotProcessing}
                          style={{
                            border: "none",
                            padding: "0",
                            color: "var(--header__color)",
                            flex: "1",
                            opacity: isBotProcessing ? 0.6 : 1,
                            cursor: isBotProcessing ? "not-allowed" : "pointer",
                          }}
                          containerStyle={{ gap: "0" }}
                          rows={3}
                        />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "2px",
                          }}
                        >
                          <Badge
                            badgeContent="BETA"
                            sx={{
                              "& .MuiBadge-badge": {
                                fontSize: "10px",
                                height: "20px",
                                minWidth: "auto",
                                backgroundColor: "#fff4e5",
                                color: "#ffa408",
                                border: "1px solid #ffa408",
                                position: "static",
                                transform: "none",
                                borderRadius: "12px",
                                fontWeight: 500,
                              },
                            }}
                          />
                          {isBotProcessing ? (
                            <AnimationPlayer
                              animationSrc={sendIconAnimation}
                              playerHeight="50px"
                              playerWidth="50px"
                            />
                          ) : (
                            <img
                              src={SendIcon}
                              alt="SendIcon"
                              onClick={handleCandidateConversation}
                              className="send-icon"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
        {chatChannelsList.length > 0 && (
          <div
            className={`chats-list-container ${
              !isChatChannelOpen ? "chat-list-close-container" : ""
            }`}
          >
            {isChatChannelOpen && (
              <CustomTooltip title={"Close Conversations"} placement="left">
                <img
                  src={isDarkMode ? CloseChatTabDarkIcon : CloseChatTabIcon}
                  alt="CloseChatTabIcon"
                  className="chat-tab-close-icon"
                  onClick={() => {
                    if (!isUIBlocked) {
                      setIsChatChannelOpen(false);
                    }
                  }}
                  style={
                    isUIBlocked ? { pointerEvents: "none", opacity: 0.6 } : {}
                  }
                />
              </CustomTooltip>
            )}
            {isChatChannelOpen ? (
              <>
                <div
                  className="chat-list-open-container"
                  ref={chatListContainerRef}
                >
                  <div className="chat-tab-icon-container">
                    <div className="chat-header-container">
                      <h3 className="chat-history-header">CONVERSATIONS</h3>
                    </div>
                  </div>
                  {renderGroupedChatChannels(groupedData)}
                  {isLoadingMore && (
                    <div className="chat-channel-loader">
                      <VybogTALLoaderAnimation />
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className="chat-list-close-container">
                <div className="chat-close-tab-icon-container">
                  <CustomTooltip title={"Open Conversations"} placement="left">
                    <img
                      src={isDarkMode ? OpenChatTabDarkIcon : OpenChatTabIcon}
                      alt="OpenChatTabIcon"
                      className="chat-tab-open-icon"
                      onClick={() => {
                        if (!isUIBlocked) {
                          setIsChatChannelOpen(true);
                        }
                      }}
                      style={
                        isUIBlocked
                          ? { pointerEvents: "none", opacity: 0.6 }
                          : {}
                      }
                    />
                  </CustomTooltip>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <ConfirmationPopup
        isOpen={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        onConfirm={() => {
          handleDeleteChannel(deleteChannelID);
          setOpenDeleteDialog(false);
        }}
        title="Delete chat?"
        confirmButtonClass="popup-button-danger"
        subTitle="Confirmation required"
        message={
          <span>
            This will delete{" "}
            <span
              style={{
                color: "#6665ea",
                fontWeight: "bold",
              }}
            >
              "{applyEllipsis(selectedChannelInitialContent, 35)}"
            </span>
            You will be unable to access the conversation again; are you sure
            you want to delete this conversation?
          </span>
        }
        confirmLabel="Yes, Delete"
        cancelLabel="No, Cancel"
      />
      <ConfirmationPopup
        isOpen={openConversationLimitPopup}
        onConfirm={() => {
          setOpenConversationLimitPopup(false);
          setIsBotProcessing(false);
        }}
        title="Conversation limit reached."
        message="You have reached the limit of this conversation. Please start a new one"
        confirmLabel="Okay"
        cancelLabel=""
      />
      <SidePopup
        key={selectedCandidate?.id || "no-candidate"}
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Candidate Details"
      >
        <CandidateDetailsContainer
          candidate={selectedCandidate}
          activeTab={activeTab}
          handleTabChange={handleTabChange}
          hasSearched={hasSearched}
          handleEditCandidate={handleEditCandidate}
          isEditingCandidate={isEditingCandidate}
          setIsEditingCandidate={setIsEditingCandidate}
          editedCandidateData={editedCandidateData}
          handleCandidateChange={(changes) =>
            setEditedCandidateData((prev) => ({ ...prev, ...changes }))
          }
          resetCandidateEdit={() => {
            setIsEditingCandidate(false);
            setEditedCandidateData(originalCandidateData);
          }}
          assignedVendor={assignedVendor}
          saveCandidateChanges={saveCandidateChanges}
        />
      </SidePopup>
      <JobsDetailsContainer
        isOpen={jobsSideContainerOpen}
        onClose={handleCloseJobsSideContainer}
        selectedJob={selectedJob}
        activeTab={jobActiveTab}
        setActiveTab={setJobActiveTab}
        formik={jobFormik}
        editedJobData={editedJobData}
        isEditable={true}
        hasSearched={hasSearched}
        jobId={selectedJob?.id}
        isEditingJob={isEditingJob}
        handleEditJob={handleEditJob}
        saveJobChanges={saveJobChanges}
        assignedCount={assignedCount}
        setAssignedCount={setAssignedCount}
        onAssignedCountChange={setAssignedCount}
        showRecommendedCandidatesTab={false}
        handleJobChange={(changes) =>
          setEditedJobData((prev) => ({ ...prev, ...changes }))
        }
        resetJobEdit={() => {
          setIsEditingJob(false);
          setEditedJobData(originalJobData);
        }}
      />
    </div>
  );
}

export default AiDrivenScreening;
